import { render } from "./BnkSetup.vue?vue&type=template&id=7644d411"
import script from "./BnkSetup.vue?vue&type=script&lang=js"
export * from "./BnkSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__